// Lib
import { Action } from 'redux';
import { IAsyncAction } from 'common/api/types';

// Constants
import * as ACTIONS from './actionTypes';
import { OverallRatingResponse, Widgets, WidgetsCalls, ProvidersRating, ProvidersRatingResponse, WidgetPageType, Review, ReviewsConfig, ReviewsFiltered } from './types';
export interface ActionSetShowPreview extends Action {
    showPreview: boolean;
}

export const SetShowPreview = (showPreview: boolean): ActionSetShowPreview => ({
    type: ACTIONS.SET_SHOW_PREVIEW,
    showPreview
});

export interface ActionGetWidgetsConfig extends Action {
    iddealer: string;
}

export interface ActionGetWidgetsPublish extends Action {
    iddealer: string;
}

export interface ActionGetReviews extends IAsyncAction {
    filter: string;
}

export interface ActionGetWidgetsHtmlCalls extends Action {
    iddealer: string;
}

export interface ActionGetOverallRating extends Action {
    iddealer: string;
    widgetPageType: string;
}

export const getGetWidgetsConfig= (iddealer: string): ActionGetWidgetsConfig => ({
    type: ACTIONS.GET_WIDGETS_CONFIG,
    iddealer
});

export const getGetWidgetsPublish= (iddealer: string): ActionGetWidgetsPublish => ({
    type: ACTIONS.GET_WIDGETS_PUBLISH,
    iddealer
});

export const getReviews = (filter: string, callback: (result: any, error: any) => void): ActionGetReviews => ({
    type: ACTIONS.GET_REVIEWS,
    filter,
    callback,
});

export const getReviewsConfig = (callback: (result: any, error: any) => void): IAsyncAction => ({
    type: ACTIONS.GET_REVIEWS_CONFIG,
    callback,
});

export const getGetWidgetsHtmlCalls= (iddealer: string): ActionGetWidgetsHtmlCalls => ({
    type: ACTIONS.GET_WIDGETS_HTML_CALLS,
    iddealer
});

export const getOverallRating = (iddealer: string, widgetPageType: WidgetPageType): ActionGetOverallRating => ({
    type: ACTIONS.GET_OVERALL_RATING,
    widgetPageType,
    iddealer
});

export interface ActionGetWidgetsConfigSuccess extends Action {
    widgets: Widgets;
}

export interface ActionGetWidgetsPublishSuccess extends Action {
    widgetsPublish: Widgets;
}

export interface ActionGetWidgetsHtmlCallsSuccess extends Action {
    widgetsCalls: WidgetsCalls;
}

export interface ActionGetOverallRatingSuccess extends Action {
    overallRating: OverallRatingResponse;
}

export interface ActionGetReviewsSuccess extends Action {
    reviews: Review[];
}

export interface ActionGetReviewsConfigSuccess extends Action {
    reviewsConfig: ReviewsConfig;
}

export const getWidgetsConfigSuccess = (widgets: Widgets): ActionGetWidgetsConfigSuccess => ({
    type: ACTIONS.GET_WIDGETS_CONFIG_SUCCESS,
    widgets
});

export const getWidgetsPublishSuccess = (widgetsPublish: Widgets): ActionGetWidgetsPublishSuccess => ({
    type: ACTIONS.GET_WIDGETS_PUBLISH_SUCCESS,
    widgetsPublish
});

export const getReviewsSuccess = (reviews: Review[]): ActionGetReviewsSuccess => ({
    type: ACTIONS.GET_REVIEWS_SUCCESS,
    reviews,
});

export const getReviewsConfigSuccess = (reviewsConfig: ReviewsConfig): ActionGetReviewsConfigSuccess => ({
    type: ACTIONS.GET_REVIEWS_CONFIG_SUCCESS,
    reviewsConfig,
});

export const getWidgetsHtmlCallsSuccess = (widgetsCalls: WidgetsCalls): ActionGetWidgetsHtmlCallsSuccess => ({
    type: ACTIONS.GET_WIDGETS_HTML_CALLS_SUCCESS,
    widgetsCalls
});

export const getOverallRatingSuccess = (overallRating: OverallRatingResponse): ActionGetOverallRatingSuccess => ({
    type: ACTIONS.GET_OVERALL_RATING_SUCCESS,
    overallRating
});

export const getWidgetsConfigError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_WIDGETS_CONFIG_ERROR,
    error
});

export const getWidgetsPublishError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_WIDGETS_PUBLISH_ERROR,
    error
});

export const getWidgetsHtmlCallsError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_WIDGETS_HTML_CALLS_ERROR,
    error
});


export interface ActionSaveWidgetsConfig extends IAsyncAction {
    widgets: Widgets;
}

export interface ActionSaveWidgetsPublish extends IAsyncAction {
    widgetsPublish: Widgets;
    selectedTab?: WidgetPageType;
}

export const saveGetWidgetsConfig= (widgets: Widgets, callback?: (result: any, error: any) => void): ActionSaveWidgetsConfig => ({
    type: ACTIONS.SAVE_WIDGETS_CONFIG,
    widgets,
    callback
});

export const saveGetWidgetsPublish= (widgetsPublish: Widgets, selectedTab: WidgetPageType, callback?: (result: any, error: any) => void): ActionSaveWidgetsPublish => ({
    type: ACTIONS.SAVE_WIDGETS_PUBLISH,
    widgetsPublish,
    selectedTab,
    callback
});

export interface ActionSaveWidgetsConfigSuccess extends Action {
    widgets: Widgets;
}

export interface ActionSaveWidgetsPublishSuccess extends Action {
    widgetsPublish: Widgets;
}

export const saveWidgetsConfigSuccess = (widgets: Widgets): ActionSaveWidgetsConfigSuccess => ({
    type: ACTIONS.SAVE_WIDGETS_CONFIG_SUCCESS,
    widgets
});

export const saveWidgetsPublishSuccess = (widgetsPublish: Widgets): ActionSaveWidgetsPublishSuccess => ({
    type: ACTIONS.SAVE_WIDGETS_PUBLISH_SUCCESS,
    widgetsPublish
});

export const saveWidgetsConfigError = (error: any): Action & { error: any } => ({
    type: ACTIONS.SAVE_WIDGETS_CONFIG_ERROR,
    error
});

export const saveWidgetsPublishError = (error: any): Action & { error: any } => ({
    type: ACTIONS.SAVE_WIDGETS_PUBLISH_ERROR,
    error
});

export interface ActionGetProvidersRating extends Action {
    iddealer: string;
}

export const getProvidersRating= (iddealer: string): ActionGetProvidersRating => ({
    type: ACTIONS.GET_PROVIDERS_RATING,
    iddealer
});

export interface ActionProvidersRatingSuccess extends Action {
    providersRating: ProvidersRatingResponse;
}

export const getProvidersRatingSuccess = (providersRating: ProvidersRatingResponse): ActionProvidersRatingSuccess => ({
    type: ACTIONS.GET_PROVIDERS_RATING_SUCCESS,
    providersRating
});

export const getProvidersRatingError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_PROVIDERS_RATING_ERROR,
    error
});

export interface ActionGetReviewsFiltered extends IAsyncAction {
    query: string;
    idDealer: string;
}

export const getReviewsFiltered = (query: string, idDealer: string, callback: (result: any, error: any) => void): ActionGetReviewsFiltered => ({
    type: ACTIONS.GET_REVIEWS_FILTERED,
    query,
    idDealer,
    callback,
});

export interface ActionGetReviewsFilteredSuccess extends Action {
    reviewsFiltered: ReviewsFiltered;
}

export interface ActionSetSelectedTabConfig extends Action {
    selectedTab: WidgetPageType;
}

export const getReviewsFilteresSuccess = (reviewsFiltered: ReviewsFiltered): ActionGetReviewsFilteredSuccess => ({
    type: ACTIONS.GET_REVIEWS_FILTERED_SUCCESS,
    reviewsFiltered,
});

export const setSelectedTabConfig = (selectedTab: WidgetPageType): ActionSetSelectedTabConfig => ({
    type: ACTIONS.SET_SELECTED_TAB_CONFIG,
    selectedTab,
});